import { Dispatch, SetStateAction, useEffect } from "react";

export function useAutoDismiss<T>(
  value: T,
  setValue: Dispatch<SetStateAction<T>>,
  emptyValue: T,
  delay = 5000
) {
  useEffect(() => {
    if (value === null || value === undefined || value === "") {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setValue(emptyValue);
    }, delay);

    return () => window.clearTimeout(timeoutId);
  }, [value, setValue, emptyValue, delay]);
}
